// import React, { useState, useRef, useEffect } from 'react';

// const CollapsibleText = ({ text, background }) => {
//   const [isExpanded, setIsExpanded] = useState(false);
//   const [isTruncated, setIsTruncated] = useState(false);
//   const textRef = useRef(null);
//   const [maxHeight, setMaxHeight] = useState('none');

//   useEffect(() => {
//     if (textRef.current) {
//       const computedStyle = getComputedStyle(textRef.current);
//       let lineHeight = computedStyle.lineHeight;

//       // If lineHeight is 'normal', we need to calculate it
//       if (lineHeight === 'normal') {
//         const fontSize = parseFloat(computedStyle.fontSize);
//         lineHeight = fontSize * 1.2; // assuming normal line height is 1.2 times the font size
//       } else {
//         lineHeight = parseFloat(lineHeight);
//       }

//       const height = textRef.current.scrollHeight;
//       const lines = height / lineHeight;
//       if (lines > 4) {
//         setIsTruncated(true);
//         setMaxHeight(`${lineHeight * 4}px`);
//       } else {
//         setIsTruncated(false);
//         setMaxHeight('none');
//       }
//     }
//   }, [text]);

//   const toggleExpanded = () => {
//     setIsExpanded(!isExpanded);
//   };
//   return (
//     <div>
//       <div
//         ref={textRef}
//         style={{
//           maxHeight: isExpanded ? 'none' : maxHeight,
//           overflow: 'hidden',
//           transition: 'max-height 0.3s ease',
//           lineHeight: '1.5', // set an explicit line-height
//           position: 'relative'
//         }}
//       > 
//         {isTruncated && !isExpanded ? `${text?.slice(0, 400)}...` : text}
//         {isTruncated && !isExpanded && (
//           <span
//             style={{
//               position: 'absolute',
//               bottom: 0,
//               right: 0,
//               background: background ? background :'white', // To prevent text overlap
//               cursor: 'pointer',
//               textDecoration: 'underline',
//               color: 'black',
//             }}
//             onClick={toggleExpanded}
//           >
//             ... Read More
//           </span>
//         )}
//       </div>
//       {isTruncated && isExpanded && (
//         <span
//           style={{ cursor: 'pointer', textDecoration: 'underline', color: 'black' }}
//           onClick={toggleExpanded}
//         >
//           Read Less
//         </span>
//       )}
//     </div>
//   );
// };

// export default CollapsibleText;

import { ContentCopy } from '@mui/icons-material';
import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';

const TextHoverLinkDiv = styled.div`
 color:blue ;
&:hover {
    /* Define hover styles here */
    text-decoration: underline;
  }
`;
const TextHoverLink = styled.span`
  color:blue ;
   cursor:pointer;
   display: inline-block;
  white-space: nowrap;       // Prevent the text from wrapping to the next line
  overflow: hidden;          // Hide the text overflow
  text-overflow: ellipsis; 
  max-width:90%;
  &:hover {
    /* Define hover styles here */
    text-decoration: underline;
  }
`;

const CollapsibleText = ({channel='', text, background = 'white', link }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState('none');

  useEffect(() => {
    if (textRef.current) {
      const computedStyle = getComputedStyle(textRef.current);
      let lineHeight = computedStyle.lineHeight;

      // If lineHeight is 'normal', we need to calculate it
      if (lineHeight === 'normal') {
        const fontSize = parseFloat(computedStyle.fontSize);
        lineHeight = fontSize * 1.2; // assuming normal line height is 1.2 times the font size
      } else {
        lineHeight = parseFloat(lineHeight);
      }

      const height = textRef.current.scrollHeight;
      const lines = height / lineHeight;
      if (lines > 4) {
        setIsTruncated(true);
        setMaxHeight(`${lineHeight * 4}px`);
      } else {
        setIsTruncated(false);
        setMaxHeight('none');
      }
    }
  }, [text]);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const newWindowFunc = () => {
    if (link) {
      window.open(link, '_blank');
      // navigator.clipboard.writeText(link).then(() => {
      //   alert('Text copied to clipboard!');
      // }).catch(err => {
      //   console.error('Failed to copy text: ', err);
      // });
    }
  }
  return (
    <div>
      <div
        ref={textRef}
        style={{
          maxHeight: isExpanded ? 'none' : maxHeight,
          overflow: 'hidden',
          transition: 'max-height 0.3s ease',
          lineHeight: '1.5', // set an explicit line-height
          position: 'relative',
          paddingBottom: isTruncated && !isExpanded ? '1.5em' : '0', // Add padding for Read More
          fontFamily: 'Inter',
          fontWeight:'300',
          maxWidth:'400px'
        }}
      >
        {isTruncated && !isExpanded ? `${text?.slice(0, 350)}` : text}
        {isTruncated && !isExpanded && (
          <div style={{ position: 'absolute', bottom: 0, right: 0, padding: '0 0.2em' }}>
            <span className="collapsible-text"
              style={{
                background,
                cursor: 'pointer',
                textDecoration: 'underline',
                color: 'black',
                fontSize: 13
              }}
              onClick={toggleExpanded}
            >
              ... Read More
            </span>
          </div>
        )}
      </div>
      {isTruncated && isExpanded && (
        <span
          style={{ cursor: 'pointer', textDecoration: 'underline', color: 'black', fontSize: 13 }}
          onClick={toggleExpanded}
        >
          Read Less
        </span>
      )}
      <TextHoverLinkDiv style={{maxWidth: channel == 'facebook' ? '350px' : ''}}>
        <TextHoverLink onClick={() => newWindowFunc()} style={{maxWidth:'90%'}}  >
          {link}

        </TextHoverLink>
        {/* {
          link 
        } */}
        {/* && <ContentCopy style={{color:'blue',marginLeft:'5px'}} onClick={() => newWindowFunc()} /> */}
      </TextHoverLinkDiv>

    </div>
  );
};

export default CollapsibleText;